
const ExpertiseTeam = () => {
  const teamMembers = [
    {
      name: "Dr. Ahmed Al-Rashid",
      position: "Chief Chemical Engineer",
      expertise: "Scale Removal & Corrosion Mitigation",
      experience: "15+ years",
      image: "https://public.readdy.ai/ai/img_res/7fadc0c6aae4020994e62d2196f40b7a.jpg",
      specializations: ["Matrix Acidizing", "Scale Inhibition", "Corrosion Analysis"]
    },
    {
      name: "Dr. Sarah Mitchell",
      position: "Senior Reservoir Engineer",
      expertise: "Enhanced Oil Recovery & Reservoir Management",
      experience: "12+ years",
      image: "https://readdy.ai/api/search-image?query=Professional%20female%20petroleum%20engineer%20in%20safety%20gear%20with%20Golden%20Black%20branding%2C%20reservoir%20management%20specialist%20in%20modern%20oil%20field%20facility&width=400&height=500&seq=engineer-2&orientation=portrait",
      specializations: ["EOR Technologies", "Reservoir Simulation", "Production Optimization"]
    },
    {
      name: "Dr. Hassan Al-Mahmoud",
      position: "Lead Production Chemist",
      expertise: "Advanced Matrix Stimulation",
      experience: "18+ years",
      image: "https://readdy.ai/api/search-image?query=Senior%20Middle%20Eastern%20production%20chemist%20with%20Golden%20Black%20logo%2C%20expert%20in%20stimulation%20technologies%20working%20in%20advanced%20chemical%20laboratory&width=400&height=500&seq=engineer-3&orientation=portrait",
      specializations: ["Well Stimulation", "Chemical Formulation", "Field Testing"]
    },
    {
      name: "Dr. Maria Rodriguez",
      position: "R&D Director",
      expertise: "Innovation & Technology Development",
      experience: "14+ years",
      image: "https://readdy.ai/api/search-image?query=Professional%20female%20research%20director%20with%20Golden%20Black%20branding%2C%20innovation%20specialist%20in%20cutting-edge%20chemical%20research%20laboratory&width=400&height=500&seq=engineer-4&orientation=portrait",
      specializations: ["New Product Development", "Technology Innovation", "Quality Assurance"]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Our Expert Engineers & Chemists
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the brilliant minds behind Golden Black's innovative chemical solutions. 
            Our team combines deep technical expertise with practical field experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-w-4 aspect-h-5">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-teal-600 font-semibold mb-2">{member.position}</p>
                <p className="text-gray-600 mb-3">{member.expertise}</p>
                <p className="text-sm text-gray-500 mb-4">Experience: {member.experience}</p>
                
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-gray-900">Specializations:</h4>
                  <div className="flex flex-wrap gap-1">
                    {member.specializations.map((spec, specIndex) => (
                      <span 
                        key={specIndex}
                        className="px-2 py-1 bg-teal-100 text-teal-800 text-xs rounded-full"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseTeam;
